module.exports = __webpack_public_path__ + "bariol_light_italic-webfont.asset.cc225f34664a9c1b67d800958e9d1192.woff";